jQuery(document).ready(function($) {
  if ($("main.property-single").length) {
    console.log("Property Single JS File");

    /******************************************
     ***     Property Single Hero Slider    ***
     ******************************************/
    var $propertySlider = $(".hero-main .owl-carousel");
    $propertySlider
      .owlCarousel({
        autoplay: false,
        loop: true,
        nav: false,
        items: 1,
        singleItem: true,
        rewind: true,
        rewindSpeed: 0,
        dots: false,
        lazyLoad: true
      })
      .on("changed.owl.carousel", function(event) {
        if ($(window).width() > 767) {
          var index = event.item.index - 1,
            count = event.item.count,
            $numbers = $(".slider-count .top").children();

          if (event.item) {
            if (index > count) {
              index -= count;
            }
            if (index <= 0) {
              index += count;
            }
            //return index;
          }

          $($numbers).removeClass("active");
          $($numbers[index - 1]).addClass("active");
        }
      });

    // Navigation Arrows for Property Single Hero Slider
    $(".property-single-hero button.next").on("click", function() {
      $propertySlider.trigger("next.owl.carousel");
    });
    $(".property-single-hero button.prev").on("click", function() {
      $propertySlider.trigger("prev.owl.carousel");
    });

    // Toggle Extra Content
    var propContent = $(".info-right .property-description .content"),
      propContentHeight = propContent.outerHeight(),
      readmoreBtn = $("button.readmore"),
      heightNum = 500;

    if (propContentHeight > heightNum) {
      propContent
        .addClass("active")
        .css({ height: heightNum + "px", overflow: "hidden" });
      readmoreBtn.addClass("active");

      readmoreBtn.toggle(
        function() {
          readmoreBtn.addClass("open");
          readmoreBtn.find(".text-cta").text("Close");
          propContent.removeClass("active").css({
            height: propContentHeight + 30 + "px",
            overflow: "hidden"
          });
        },
        function() {
          readmoreBtn.removeClass("open");
          readmoreBtn.find(".text-cta").text("Read More");
          propContent
            .addClass("active")
            .css({ height: heightNum + "px", overflow: "hidden" });
        }
      );
    }

    // Expand button for Property Single Hero Slider
    var $pshero = $(".property-single-hero .container");

    $("#expand").click(function(event) {
      $(".hero-main .owl-carousel").addClass("transitioning");
      if ($($pshero).hasClass("expand-active")) {
        closeExpand();
      } else {
        openExpand();
      }
    });

    function closeExpand() {
      $("body").removeClass("expand-active");
      $pshero.removeClass("expand-active");
      $("#expand").disabled = true;

      setTimeout(function() {
        $("#expand").disabled = false;

        $(window).trigger("resize");
        $propertySlider.trigger("refresh.owl.carousel");

        $(".hero-main .owl-carousel").removeClass("transitioning");
      }, 1000);
    }

    function openExpand() {
      $("body").addClass("expand-active");
      $pshero.addClass("expand-active");
      $("#expand").disabled = true;

      setTimeout(function() {
        $("#expand").disabled = false;

        $(window).trigger("resize");
        $propertySlider.trigger("refresh.owl.carousel");

        $(".hero-main .owl-carousel").removeClass("transitioning");
      }, 1000);
    }
    /******************************************
     ***  END Property Single Hero Slider   ***
     ******************************************/

    /******************************************
     ***     Show Property on Google Maps   ***
     ******************************************/
    if ($(".property-single-map").length) {
      var lat = $("#map").data("lat");
      var long = $("#map").data("long");
      var myLatlng = {};
      myLatlng.lat = lat;
      myLatlng.lng = long;
      google.maps.event.addDomListener(window, "load", init);

      function init() {
        var mapOptions = {
          zoom: 16,
          scrollwheel: false,
          draggable: true,
          center: new google.maps.LatLng(lat, long),
          styles: [
            {
              featureType: "administrative",
              elementType: "labels.text.fill",
              stylers: [{ color: "#444444" }]
            },
            {
              featureType: "landscape",
              elementType: "all",
              stylers: [{ color: "#f2f2f2" }]
            },
            {
              featureType: "poi",
              elementType: "all",
              stylers: [{ visibility: "off" }]
            },
            {
              featureType: "road",
              elementType: "all",
              stylers: [{ saturation: -100 }, { lightness: 45 }]
            },
            {
              featureType: "road",
              elementType: "labels.text",
              stylers: [{ color: "#0b2a47" }]
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ffffff" }]
            },
            {
              featureType: "road.highway",
              elementType: "all",
              stylers: [{ visibility: "simplified" }]
            },
            {
              featureType: "road.arterial",
              elementType: "labels.icon",
              stylers: [{ visibility: "off" }]
            },
            {
              featureType: "transit",
              elementType: "all",
              stylers: [{ visibility: "off" }]
            },
            {
              featureType: "water",
              elementType: "all",
              stylers: [{ color: "#47ace9" }, { visibility: "on" }]
            }
          ]
        };
        var mapElement = document.getElementById("map");
        var map = new google.maps.Map(mapElement, mapOptions);
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(lat, long),
          map: map,
          icon: my_template_url + "/assets/images/icons/harcourts-map-icon.png"
        });

        // Recenters map Orientation
        // map.addListener("center_changed", function() {
        //   window.setTimeout(function() {
        //     map.panTo(marker.getPosition());
        //   }, 500);
        // });
      }
    }
    /******************************************
     ***  END Show Property on Google Maps  ***
     ******************************************/

    /******************************************
     ***     Similiar Properties            ***
     ******************************************/
    var $similiarSlider = $(".similiar-properties .owl-carousel");
    $similiarSlider
      .owlCarousel({
        autoplay: false,
        loop: false,
        nav: false,
        margin: 0,
        dots: false,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        lazyLoad: true,
        items: 1,
        responsive: {
          768: {
            items: 2,
            margin: 40
          },
          950: {
            items: 3,
            margin: 40
          },
          1200: {
            items: 4,
            margin: 40
          }
        }
      })
      .on("changed.owl.carousel", function(e) {
        $(".click-drag").fadeOut();

        var itemIndex = e.item.index;
        if (itemIndex == 0) {
          $(".click-drag").fadeIn();
        }
      });

    /******************************************
     ***     END Similiar Properties        ***
     ******************************************/

    /******************************************
     ***     Down Arrow SCroll More      ***
     ******************************************/
    $(".down-arrow").on("click", function(e) {
      e.preventDefault();
      var $target = $(".property-single-intro");
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top
          },
          500,
          "swing"
        );
    });

    /******************************************
     ***      Register to Bid Form          ***
     ******************************************/
    // console.log(form_id);
    function gravityFormsID($id) {
      $("input#input_" + $id + "_1").attr("name", "Bidder_UserName");
      $("input#input_" + $id + "_2").attr("name", "Bidder_Email");
      $("input#input_" + $id + "_3").attr("name", "BIDDER_PHONE");
      $("input#input_" + $id + "_4").attr("name", "BIDDER_ADDRESS");
      $("input#input_" + $id + "_5").attr("name", "BIDDER_IDENTIFICATION");
      $("input#input_" + $id + "_6").attr("name", "State");
      $("select#input_" + $id + "_8").attr("name", "Bidding Mode");
    }

    // Form IDS "var form_id = "
    // Hawaii = 2
    // Nevada = 10
    // Oregon = 11
    // California = 12

    //gravityFormsID(form_id);

    console.log('GF form_id', form_id);


    $(document).on("gform_post_render", function(event, form_id, current_page) {
      console.log("gform_post_render:", event);
      console.log("form_id:", form_id);

      // This event handler needs to be placed in the render listener
      // because we're using a multipart form
      $("#gform_" + form_id + " [type='submit']").click(function(e) {
        console.log(form_id);
        $(".register-to-bid-contain").addClass("block-ui ");
        $bidName = $("input#input_" + form_id + "_29_3").val() + ' ' + $("input#input_" + form_id + "_29_6").val();
        $bidEmail = $("input#input_" + form_id + "_2").val();
        $bidPhone = $("input#input_" + form_id + "_3").val();
        $bidAddress = $("input#input_" + form_id + "_4").val();
        $bidDL = $("input#input_" + form_id + "_5").val();
        $bidState = $("input#input_" + form_id + "_6").val();
        $bidMode = $("select#input_" + form_id + "_8").val();

        $('form.register-to-bid [name="Bidder_UserName"]').val($bidName);
        $('form.register-to-bid [name="Bidder_Email"]').val($bidEmail);
        $('form.register-to-bid [name="BIDDER_PHONE"]').val($bidPhone);
        $('form.register-to-bid [name="BIDDER_ADDRESS"]').val($bidAddress);
        $('form.register-to-bid [name="BIDDER_IDENTIFICATION"]').val($bidDL);
        $('form.register-to-bid [name="State"]').val($bidState);
        $('form.register-to-bid [name="Bidding Mode"]').val($bidMode);

        setTimeout(function() {
          if ($("#gform_" + form_id + " li.gfield").hasClass("gfield_error")) {
            $(".register-to-bid-contain").removeClass("block-ui ");
          }
        }, 1000);
      });

      setTimeout(function() {
        $(".register-to-bid-contain").removeClass("block-ui ");
      }, 600);
    });

    $(document).on("gform_confirmation_loaded", function(e, form_id) {
      // code to run upon successful form submission

      // Automatically
      if ($("input#input_" + form_id + "_21").val() === "A Buyer") {
        setTimeout(function() {
          $(".register-to-bid").submit();
        }, 5000);
      }

      // Manual
      $('#continueToBiddingReg').click(function(){
        $(".register-to-bid").submit();
      });

      console.log("https://na2.docusign.net/Member/PowerFormSigning.aspx?" + jQuery(".register-to-bid").serialize());
    });
    // Register to Bid - DocuSign redirect
    // $("form.register-to-bid-cal").submit(function(event) {
    //   //event.preventDefault();

    //   var formObject = $(this).serializeArray(),
    //     formURL = "/gravityformsapi/forms/12/submissions",
    //     formData = {
    //       input_values: {
    //         input_1: formObject[0].value, // bidder name
    //         input_2: formObject[1].value, // bidder email
    //         input_3: formObject[2].value, // phone number
    //         input_4: formObject[3].value, // user's address
    //         input_5: formObject[4].value, // driver's license
    //         input_6: formObject[5].value, // user's US state
    //         input_8: formObject[6].value, // how user will be attending the auction
    //         input_9: formObject[7].value, // live auction location
    //         input_10: formObject[8].value // property's address
    //       }
    //     };

    //   console.table(formObject);
    //   //console.table(formData);

    //   $.ajax({
    //     //url: formURL,
    //     method: "POST",
    //     data: formObject,
    //     beforeSend: function() {
    //       console.log("before");
    //     },
    //     error: function() {
    //       console.log("error");
    //     },
    //     success: function(data) {
    //       console.log("Success Confirmation message:", data);
    //       $(".register-to-bid-contain")
    //         .children()
    //         .html(data);
    //     },
    //     complete: function(data) {
    //       console.log("completed");
    //       setTimeout(function() {
    //         $("form.register-to-bid").submit();
    //       }, 1000);
    //     }
    //   });
    // });

    /******************************************
     ***     END Register to Bid Form       ***
     ******************************************/

    /******************************************
     ***    Download Document Form       ***
     ******************************************/
    // $("form.disclosure-docs button[type=submit]").click(function(event) {
    //   event.preventDefault();

    //   var formObject = $("form.disclosure-docs").serializeArray(),
    //     formURL = "/gravityformsapi/forms/4/submissions",
    //     formData = {
    //       input_values: {
    //         input_1: formObject[0].value, // First Name
    //         input_5: formObject[1].value, // Last Name
    //         input_2: formObject[2].value, // Email
    //         input_4: formObject[3].value // Phone
    //       }
    //     };

    //   //console.table(disclosureDoc);
    //   console.table(formObject);

    //   $.ajax({
    //     type: "POST",
    //     // url: formURL,
    //     data: $("form.disclosure-docs").serialize(),
    //     beforeSend: function() {
    //       console.log("before");
    //       $(".disclosure-form").addClass("block-ui ");
    //     },
    //     error: function() {
    //       console.log("error");
    //     },
    //     success: function(data) {
    //       console.log("success");
    //       $("form.disclosure-docs").submit();
    //     },
    //     complete: function(data) {
    //       console.log("completed");
    //     }
    //   });
    // });

    $("form.disclosure-docs").submit(function() {
      var formObject = $(this).serializeArray(),
        formURL = "/gravityformsapi/forms/4/submissions",
        formData = {
          input_values: {
            input_1: formObject[0].value, // First Name
            input_5: formObject[1].value, // Last Name
            input_2: formObject[2].value, // Email
            input_4: formObject[3].value // Phone
          }
        };

      //console.table(disclosureDoc);
      console.table(formObject);

      $.ajax({
        type: "POST",
        // url: formURL,
        data: formObject,
        beforeSend: function() {
          console.log("before");
          $(".disclosure-form").addClass("block-ui ");
        },
        error: function() {
          console.log("error");
        },
        success: function(data) {
          console.log("Success Confirmation message:", data);
          $(".disclosure-form").removeClass("block-ui ");
          $(".disclosure-form")
            .children()
            .html(data);
        },
        complete: function(data) {
          console.log("completed");
          $(".pdf-download.downloadDocs").attr("href", disclosureDoc);
        }
      });
      return false;
    });
    /******************************************
     ***     END Request a Showing Form     ***
     ******************************************/
    // jQuery(document).on("gform_confirmation_loaded", function(event, formId) {
    //   if (formId == 4) {
    //     // run code specific to form ID 1
    //     $(".pdf-download.downloadDocs").attr("href", disclosureDoc);
    //     $(".disclosure-form").removeClass("block-ui ");
    //   }
    // });
  }
});
